import React from 'react'
import { SvgProps } from 'src/shared/types/svg-props-type'

export const Percent03Icon = (props?: SvgProps) => (
  <svg
    height="20"
    width="20"
    fill="none"
    viewBox="0 0 20 20"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <title>{props?.title}</title>
    <g clipPath="url(#clip0_12834_762)">
      <path
        d="M17.5 9.99992C17.5 5.85778 14.1421 2.49992 10 2.49992C5.85787 2.49992 2.50001 5.85778 2.50001 9.99992C2.50001 14.1421 5.85787 17.4999 10 17.4999C14.1421 17.4999 17.5 14.1421 17.5 9.99992ZM12.7441 6.07739C13.0696 5.75196 13.5971 5.75196 13.9225 6.07739C14.248 6.40283 14.248 6.93034 13.9225 7.25578L7.25587 13.9224C6.93043 14.2479 6.40292 14.2479 6.07748 13.9224C5.75205 13.597 5.75205 13.0695 6.07748 12.7441L12.7441 6.07739ZM12.5 11.2499C13.1904 11.2499 13.75 11.8096 13.75 12.4999C13.75 13.1903 13.1904 13.7499 12.5 13.7499C11.8097 13.7499 11.25 13.1903 11.25 12.4999C11.25 11.8096 11.8097 11.2499 12.5 11.2499ZM7.50001 6.24992C8.19037 6.24992 8.75001 6.80956 8.75001 7.49992C8.75001 8.19027 8.19037 8.74992 7.50001 8.74992C6.80965 8.74992 6.25001 8.19027 6.25001 7.49992C6.25001 6.80956 6.80965 6.24992 7.50001 6.24992ZM19.1667 9.99992C19.1667 15.0625 15.0626 19.1666 10 19.1666C4.9374 19.1666 0.833344 15.0625 0.833344 9.99992C0.833344 4.93731 4.9374 0.833252 10 0.833252C15.0626 0.833252 19.1667 4.93731 19.1667 9.99992Z"
        fill="#474A53"
      />
    </g>
    <defs>
      <clipPath id="clip0_12834_762">
        <rect height="20" width="20" fill="white" />
      </clipPath>
    </defs>
  </svg>
)
